<template>
  <div class="parts-details-card">
    <section class="parts-details-card-main">
      <PCPartsDetailsCardMainHeader class="part-details-card-header" />
      <PCPartsDetailsCardMainBody class="part-details-card-body" />
    </section>

    <section>
      <PCPartsDetailsCardArticles />
    </section>
  </div>
</template>

<script setup>
// @ts-check

import PCPartsDetailsCardArticles from './PCPartsDetailsCardArticles.vue';
import PCPartsDetailsCardMainBody from './PCPartsDetailsCardMainBody.vue';
import PCPartsDetailsCardMainHeader from './PCPartsDetailsCardMainHeader.vue';
</script>

<style scoped lang="scss">
.parts-details-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: calc(var(--f7-typography-padding) * 2);
  background-color: #fff;
  border-radius: 8px;
  padding-bottom: var(--f7-typography-padding);
}

.parts-details-card-main {
  display: flex;
  flex-direction: column;

  .part-details-card-header,
  .part-details-card-body {
    padding: var(--f7-typography-padding);
  }
}
</style>
